import React from 'react'
import StyledMenu from './VerticalMenu.styles'
import MenuHeader from './MenuHeader'
import NestedList from './NestedList'

export default function VerticalMenu({
    title = '',
    titleLink,
    open,
    setOpen,
    items,
    disabled,
}) {
    return (
        <StyledMenu>
            <MenuHeader
                open={open}
                setOpen={setOpen}
                title={title}
                link={titleLink}
                disabled={disabled}
            />
            {(open || disabled) && <NestedList items={items} />}
        </StyledMenu>
    )
}
